export const googleFonts = {
    "ABeeZee": {
        "family": "ABeeZee",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Abel": {
        "family": "Abel",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Abhaya-Libre": {
        "family": "Abhaya Libre",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "sinhala"
        ]
    },
    "Abril-Fatface": {
        "family": "Abril Fatface",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Aclonica": {
        "family": "Aclonica",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Acme": {
        "family": "Acme",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Actor": {
        "family": "Actor",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Adamina": {
        "family": "Adamina",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Advent-Pro": {
        "family": "Advent Pro",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "greek",
            "latin",
            "latin-ext"
        ]
    },
    "Aguafina-Script": {
        "family": "Aguafina Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Akaya-Kanadaka": {
        "family": "Akaya Kanadaka",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "kannada",
            "latin",
            "latin-ext"
        ]
    },
    "Akaya-Telivigala": {
        "family": "Akaya Telivigala",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "telugu"
        ]
    },
    "Akronim": {
        "family": "Akronim",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Aladin": {
        "family": "Aladin",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Alata": {
        "family": "Alata",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alatsi": {
        "family": "Alatsi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Aldrich": {
        "family": "Aldrich",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Alef": {
        "family": "Alef",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "hebrew",
            "latin"
        ]
    },
    "Alegreya": {
        "family": "Alegreya",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alegreya-SC": {
        "family": "Alegreya SC",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alegreya-Sans": {
        "family": "Alegreya Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alegreya-Sans-SC": {
        "family": "Alegreya Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Aleo": {
        "family": "Aleo",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Alex-Brush": {
        "family": "Alex Brush",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alfa-Slab-One": {
        "family": "Alfa Slab One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Alice": {
        "family": "Alice",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Alike": {
        "family": "Alike",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Alike-Angular": {
        "family": "Alike Angular",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Allan": {
        "family": "Allan",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Allerta": {
        "family": "Allerta",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Allerta-Stencil": {
        "family": "Allerta Stencil",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Allison": {
        "family": "Allison",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Allura": {
        "family": "Allura",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Almarai": {
        "family": "Almarai",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "arabic"
        ]
    },
    "Almendra": {
        "family": "Almendra",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Almendra-Display": {
        "family": "Almendra Display",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Almendra-SC": {
        "family": "Almendra SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Alumni-Sans": {
        "family": "Alumni Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Amarante": {
        "family": "Amarante",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Amaranth": {
        "family": "Amaranth",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Amatic-SC": {
        "family": "Amatic SC",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Amethysta": {
        "family": "Amethysta",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Amiko": {
        "family": "Amiko",
        "category": "sans-serif",
        "variants": [
            "400",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Amiri": {
        "family": "Amiri",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Amita": {
        "family": "Amita",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Anaheim": {
        "family": "Anaheim",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Andada-Pro": {
        "family": "Andada Pro",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Andika": {
        "family": "Andika",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Andika-New-Basic": {
        "family": "Andika New Basic",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Angkor": {
        "family": "Angkor",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Annie-Use-Your-Telescope": {
        "family": "Annie Use Your Telescope",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Anonymous-Pro": {
        "family": "Anonymous Pro",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "latin",
            "latin-ext"
        ]
    },
    "Antic": {
        "family": "Antic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Antic-Didone": {
        "family": "Antic Didone",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Antic-Slab": {
        "family": "Antic Slab",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Anton": {
        "family": "Anton",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Antonio": {
        "family": "Antonio",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Arapey": {
        "family": "Arapey",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Arbutus": {
        "family": "Arbutus",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Arbutus-Slab": {
        "family": "Arbutus Slab",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Architects-Daughter": {
        "family": "Architects Daughter",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Archivo": {
        "family": "Archivo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Archivo-Black": {
        "family": "Archivo Black",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Archivo-Narrow": {
        "family": "Archivo Narrow",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Are-You-Serious": {
        "family": "Are You Serious",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Aref-Ruqaa": {
        "family": "Aref Ruqaa",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Arima-Madurai": {
        "family": "Arima Madurai",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil",
            "vietnamese"
        ]
    },
    "Arimo": {
        "family": "Arimo",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Arizonia": {
        "family": "Arizonia",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Armata": {
        "family": "Armata",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Arsenal": {
        "family": "Arsenal",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Artifika": {
        "family": "Artifika",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Arvo": {
        "family": "Arvo",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Arya": {
        "family": "Arya",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Asap": {
        "family": "Asap",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Asap-Condensed": {
        "family": "Asap Condensed",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Asar": {
        "family": "Asar",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Asset": {
        "family": "Asset",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Assistant": {
        "family": "Assistant",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Astloch": {
        "family": "Astloch",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Asul": {
        "family": "Asul",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Athiti": {
        "family": "Athiti",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Atkinson-Hyperlegible": {
        "family": "Atkinson Hyperlegible",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Atma": {
        "family": "Atma",
        "category": "display",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "bengali",
            "latin",
            "latin-ext"
        ]
    },
    "Atomic-Age": {
        "family": "Atomic Age",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Aubrey": {
        "family": "Aubrey",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Audiowide": {
        "family": "Audiowide",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Autour-One": {
        "family": "Autour One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Average": {
        "family": "Average",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Average-Sans": {
        "family": "Average Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Averia-Gruesa-Libre": {
        "family": "Averia Gruesa Libre",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Averia-Libre": {
        "family": "Averia Libre",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Averia-Sans-Libre": {
        "family": "Averia Sans Libre",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Averia-Serif-Libre": {
        "family": "Averia Serif Libre",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Azeret-Mono": {
        "family": "Azeret Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "B612": {
        "family": "B612",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "B612-Mono": {
        "family": "B612 Mono",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bad-Script": {
        "family": "Bad Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin"
        ]
    },
    "Bahiana": {
        "family": "Bahiana",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bahianita": {
        "family": "Bahianita",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bai-Jamjuree": {
        "family": "Bai Jamjuree",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Bakbak-One": {
        "family": "Bakbak One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Ballet": {
        "family": "Ballet",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-2": {
        "family": "Baloo 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Bhai-2": {
        "family": "Baloo Bhai 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Bhaijaan-2": {
        "family": "Baloo Bhaijaan 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Bhaina-2": {
        "family": "Baloo Bhaina 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "oriya",
            "vietnamese"
        ]
    },
    "Baloo-Chettan-2": {
        "family": "Baloo Chettan 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "malayalam",
            "vietnamese"
        ]
    },
    "Baloo-Da-2": {
        "family": "Baloo Da 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "bengali",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Paaji-2": {
        "family": "Baloo Paaji 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "gurmukhi",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Tamma-2": {
        "family": "Baloo Tamma 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "kannada",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Baloo-Tammudu-2": {
        "family": "Baloo Tammudu 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "telugu",
            "vietnamese"
        ]
    },
    "Baloo-Thambi-2": {
        "family": "Baloo Thambi 2",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil",
            "vietnamese"
        ]
    },
    "Balsamiq-Sans": {
        "family": "Balsamiq Sans",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Balthazar": {
        "family": "Balthazar",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bangers": {
        "family": "Bangers",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Barlow": {
        "family": "Barlow",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Barlow-Condensed": {
        "family": "Barlow Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Barlow-Semi-Condensed": {
        "family": "Barlow Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Barriecito": {
        "family": "Barriecito",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Barrio": {
        "family": "Barrio",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Basic": {
        "family": "Basic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Baskervville": {
        "family": "Baskervville",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Battambang": {
        "family": "Battambang",
        "category": "display",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Baumans": {
        "family": "Baumans",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bayon": {
        "family": "Bayon",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Be-Vietnam-Pro": {
        "family": "Be Vietnam Pro",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bebas-Neue": {
        "family": "Bebas Neue",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Belgrano": {
        "family": "Belgrano",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bellefair": {
        "family": "Bellefair",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Belleza": {
        "family": "Belleza",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bellota": {
        "family": "Bellota",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bellota-Text": {
        "family": "Bellota Text",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "BenchNine": {
        "family": "BenchNine",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Benne": {
        "family": "Benne",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "kannada",
            "latin",
            "latin-ext"
        ]
    },
    "Bentham": {
        "family": "Bentham",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Berkshire-Swash": {
        "family": "Berkshire Swash",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Besley": {
        "family": "Besley",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Beth-Ellen": {
        "family": "Beth Ellen",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bevan": {
        "family": "Bevan",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "BhuTuka-Expanded-One": {
        "family": "BhuTuka Expanded One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gurmukhi",
            "latin",
            "latin-ext"
        ]
    },
    "Big-Shoulders-Display": {
        "family": "Big Shoulders Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Big-Shoulders-Inline-Display": {
        "family": "Big Shoulders Inline Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Big-Shoulders-Inline-Text": {
        "family": "Big Shoulders Inline Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Big-Shoulders-Stencil-Display": {
        "family": "Big Shoulders Stencil Display",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Big-Shoulders-Stencil-Text": {
        "family": "Big Shoulders Stencil Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Big-Shoulders-Text": {
        "family": "Big Shoulders Text",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bigelow-Rules": {
        "family": "Bigelow Rules",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bigshot-One": {
        "family": "Bigshot One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bilbo": {
        "family": "Bilbo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bilbo-Swash-Caps": {
        "family": "Bilbo Swash Caps",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "BioRhyme": {
        "family": "BioRhyme",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "BioRhyme-Expanded": {
        "family": "BioRhyme Expanded",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Birthstone": {
        "family": "Birthstone",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Birthstone-Bounce": {
        "family": "Birthstone Bounce",
        "category": "handwriting",
        "variants": [
            "400",
            "500"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Biryani": {
        "family": "Biryani",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Bitter": {
        "family": "Bitter",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Black-And-White-Picture": {
        "family": "Black And White Picture",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Black-Han-Sans": {
        "family": "Black Han Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Black-Ops-One": {
        "family": "Black Ops One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Blinker": {
        "family": "Blinker",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bodoni-Moda": {
        "family": "Bodoni Moda",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bokor": {
        "family": "Bokor",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Bona-Nova": {
        "family": "Bona Nova",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bonbon": {
        "family": "Bonbon",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bonheur-Royale": {
        "family": "Bonheur Royale",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Boogaloo": {
        "family": "Boogaloo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bowlby-One": {
        "family": "Bowlby One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bowlby-One-SC": {
        "family": "Bowlby One SC",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Brawler": {
        "family": "Brawler",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Bree-Serif": {
        "family": "Bree Serif",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Brygada-1918": {
        "family": "Brygada 1918",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bubblegum-Sans": {
        "family": "Bubblegum Sans",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bubbler-One": {
        "family": "Bubbler One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Buda": {
        "family": "Buda",
        "category": "display",
        "variants": [
            "300"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Buenard": {
        "family": "Buenard",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Bungee": {
        "family": "Bungee",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bungee-Hairline": {
        "family": "Bungee Hairline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bungee-Inline": {
        "family": "Bungee Inline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bungee-Outline": {
        "family": "Bungee Outline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Bungee-Shade": {
        "family": "Bungee Shade",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Butcherman": {
        "family": "Butcherman",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Butterfly-Kids": {
        "family": "Butterfly Kids",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cabin": {
        "family": "Cabin",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cabin-Condensed": {
        "family": "Cabin Condensed",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cabin-Sketch": {
        "family": "Cabin Sketch",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Caesar-Dressing": {
        "family": "Caesar Dressing",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cagliostro": {
        "family": "Cagliostro",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cairo": {
        "family": "Cairo",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Caladea": {
        "family": "Caladea",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Calistoga": {
        "family": "Calistoga",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Calligraffitti": {
        "family": "Calligraffitti",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cambay": {
        "family": "Cambay",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Cambo": {
        "family": "Cambo",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Candal": {
        "family": "Candal",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cantarell": {
        "family": "Cantarell",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cantata-One": {
        "family": "Cantata One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cantora-One": {
        "family": "Cantora One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Capriola": {
        "family": "Capriola",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Caramel": {
        "family": "Caramel",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Carattere": {
        "family": "Carattere",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cardo": {
        "family": "Cardo",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Carme": {
        "family": "Carme",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Carrois-Gothic": {
        "family": "Carrois Gothic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Carrois-Gothic-SC": {
        "family": "Carrois Gothic SC",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Carter-One": {
        "family": "Carter One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Castoro": {
        "family": "Castoro",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Catamaran": {
        "family": "Catamaran",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil"
        ]
    },
    "Caudex": {
        "family": "Caudex",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Caveat": {
        "family": "Caveat",
        "category": "handwriting",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Caveat-Brush": {
        "family": "Caveat Brush",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cedarville-Cursive": {
        "family": "Cedarville Cursive",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Ceviche-One": {
        "family": "Ceviche One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chakra-Petch": {
        "family": "Chakra Petch",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Changa": {
        "family": "Changa",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Changa-One": {
        "family": "Changa One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Chango": {
        "family": "Chango",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Charm": {
        "family": "Charm",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Charmonman": {
        "family": "Charmonman",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Chathura": {
        "family": "Chathura",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Chau-Philomene-One": {
        "family": "Chau Philomene One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chela-One": {
        "family": "Chela One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chelsea-Market": {
        "family": "Chelsea Market",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chenla": {
        "family": "Chenla",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Cherish": {
        "family": "Cherish",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cherry-Cream-Soda": {
        "family": "Cherry Cream Soda",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cherry-Swash": {
        "family": "Cherry Swash",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chewy": {
        "family": "Chewy",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Chicle": {
        "family": "Chicle",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chilanka": {
        "family": "Chilanka",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "malayalam"
        ]
    },
    "Chivo": {
        "family": "Chivo",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Chonburi": {
        "family": "Chonburi",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Cinzel": {
        "family": "Cinzel",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cinzel-Decorative": {
        "family": "Cinzel Decorative",
        "category": "display",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Clicker-Script": {
        "family": "Clicker Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Coda": {
        "family": "Coda",
        "category": "display",
        "variants": [
            "400",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Coda-Caption": {
        "family": "Coda Caption",
        "category": "sans-serif",
        "variants": [
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Codystar": {
        "family": "Codystar",
        "category": "display",
        "variants": [
            "300",
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Coiny": {
        "family": "Coiny",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil",
            "vietnamese"
        ]
    },
    "Combo": {
        "family": "Combo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Comfortaa": {
        "family": "Comfortaa",
        "category": "display",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Comforter": {
        "family": "Comforter",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Comforter-Brush": {
        "family": "Comforter Brush",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Comic-Neue": {
        "family": "Comic Neue",
        "category": "handwriting",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Coming-Soon": {
        "family": "Coming Soon",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Commissioner": {
        "family": "Commissioner",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Concert-One": {
        "family": "Concert One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Condiment": {
        "family": "Condiment",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Content": {
        "family": "Content",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Contrail-One": {
        "family": "Contrail One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Convergence": {
        "family": "Convergence",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cookie": {
        "family": "Cookie",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Copse": {
        "family": "Copse",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Corben": {
        "family": "Corben",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Corinthia": {
        "family": "Corinthia",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant": {
        "family": "Cormorant",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant-Garamond": {
        "family": "Cormorant Garamond",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant-Infant": {
        "family": "Cormorant Infant",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant-SC": {
        "family": "Cormorant SC",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant-Unicase": {
        "family": "Cormorant Unicase",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cormorant-Upright": {
        "family": "Cormorant Upright",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Courgette": {
        "family": "Courgette",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Courier-Prime": {
        "family": "Courier Prime",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cousine": {
        "family": "Cousine",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Coustard": {
        "family": "Coustard",
        "category": "serif",
        "variants": [
            "400",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Covered-By-Your-Grace": {
        "family": "Covered By Your Grace",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Crafty-Girls": {
        "family": "Crafty Girls",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Creepster": {
        "family": "Creepster",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Crete-Round": {
        "family": "Crete Round",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Crimson-Pro": {
        "family": "Crimson Pro",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Croissant-One": {
        "family": "Croissant One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Crushed": {
        "family": "Crushed",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Cuprum": {
        "family": "Cuprum",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Cute-Font": {
        "family": "Cute Font",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Cutive": {
        "family": "Cutive",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Cutive-Mono": {
        "family": "Cutive Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "DM-Mono": {
        "family": "DM Mono",
        "category": "monospace",
        "variants": [
            "300",
            "400",
            "500"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "DM-Sans": {
        "family": "DM Sans",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "DM-Serif-Display": {
        "family": "DM Serif Display",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "DM-Serif-Text": {
        "family": "DM Serif Text",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Damion": {
        "family": "Damion",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Dancing-Script": {
        "family": "Dancing Script",
        "category": "handwriting",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Dangrek": {
        "family": "Dangrek",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Darker-Grotesque": {
        "family": "Darker Grotesque",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "David-Libre": {
        "family": "David Libre",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Dawning-of-a-New-Day": {
        "family": "Dawning of a New Day",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Days-One": {
        "family": "Days One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Dekko": {
        "family": "Dekko",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Dela-Gothic-One": {
        "family": "Dela Gothic One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Delius": {
        "family": "Delius",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Delius-Swash-Caps": {
        "family": "Delius Swash Caps",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Delius-Unicase": {
        "family": "Delius Unicase",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Della-Respira": {
        "family": "Della Respira",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Denk-One": {
        "family": "Denk One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Devonshire": {
        "family": "Devonshire",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Dhurjati": {
        "family": "Dhurjati",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Didact-Gothic": {
        "family": "Didact Gothic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Diplomata": {
        "family": "Diplomata",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Diplomata-SC": {
        "family": "Diplomata SC",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Do-Hyeon": {
        "family": "Do Hyeon",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Dokdo": {
        "family": "Dokdo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Domine": {
        "family": "Domine",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Donegal-One": {
        "family": "Donegal One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Dongle": {
        "family": "Dongle",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "korean",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Doppio-One": {
        "family": "Doppio One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Dorsa": {
        "family": "Dorsa",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Dosis": {
        "family": "Dosis",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "DotGothic16": {
        "family": "DotGothic16",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Dr-Sugiyama": {
        "family": "Dr Sugiyama",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Duru-Sans": {
        "family": "Duru Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Dynalight": {
        "family": "Dynalight",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "EB-Garamond": {
        "family": "EB Garamond",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Eagle-Lake": {
        "family": "Eagle Lake",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "East-Sea-Dokdo": {
        "family": "East Sea Dokdo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Eater": {
        "family": "Eater",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Economica": {
        "family": "Economica",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Eczar": {
        "family": "Eczar",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "El-Messiri": {
        "family": "El Messiri",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Electrolize": {
        "family": "Electrolize",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Elsie": {
        "family": "Elsie",
        "category": "display",
        "variants": [
            "400",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Elsie-Swash-Caps": {
        "family": "Elsie Swash Caps",
        "category": "display",
        "variants": [
            "400",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Emblema-One": {
        "family": "Emblema One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Emilys-Candy": {
        "family": "Emilys Candy",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Encode-Sans": {
        "family": "Encode Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Encode-Sans-Condensed": {
        "family": "Encode Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Encode-Sans-Expanded": {
        "family": "Encode Sans Expanded",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Encode-Sans-SC": {
        "family": "Encode Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Encode-Sans-Semi-Condensed": {
        "family": "Encode Sans Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Encode-Sans-Semi-Expanded": {
        "family": "Encode Sans Semi Expanded",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Engagement": {
        "family": "Engagement",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Englebert": {
        "family": "Englebert",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Enriqueta": {
        "family": "Enriqueta",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ephesis": {
        "family": "Ephesis",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Epilogue": {
        "family": "Epilogue",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Erica-One": {
        "family": "Erica One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Esteban": {
        "family": "Esteban",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Estonia": {
        "family": "Estonia",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Euphoria-Script": {
        "family": "Euphoria Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ewert": {
        "family": "Ewert",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Exo": {
        "family": "Exo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Exo-2": {
        "family": "Exo 2",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Expletus-Sans": {
        "family": "Expletus Sans",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Explora": {
        "family": "Explora",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cherokee",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fahkwang": {
        "family": "Fahkwang",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Fanwood-Text": {
        "family": "Fanwood Text",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Farro": {
        "family": "Farro",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Farsan": {
        "family": "Farsan",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fascinate": {
        "family": "Fascinate",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Fascinate-Inline": {
        "family": "Fascinate Inline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Faster-One": {
        "family": "Faster One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Fasthand": {
        "family": "Fasthand",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Fauna-One": {
        "family": "Fauna One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Faustina": {
        "family": "Faustina",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Federant": {
        "family": "Federant",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Federo": {
        "family": "Federo",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Felipa": {
        "family": "Felipa",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fenix": {
        "family": "Fenix",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Festive": {
        "family": "Festive",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Finger-Paint": {
        "family": "Finger Paint",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Fira-Code": {
        "family": "Fira Code",
        "category": "monospace",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Fira-Mono": {
        "family": "Fira Mono",
        "category": "monospace",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Fira-Sans": {
        "family": "Fira Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fira-Sans-Condensed": {
        "family": "Fira Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fira-Sans-Extra-Condensed": {
        "family": "Fira Sans Extra Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fjalla-One": {
        "family": "Fjalla One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fjord-One": {
        "family": "Fjord One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Flamenco": {
        "family": "Flamenco",
        "category": "display",
        "variants": [
            "300",
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Flavors": {
        "family": "Flavors",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fleur-De-Leah": {
        "family": "Fleur De Leah",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Flow-Block": {
        "family": "Flow Block",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Flow-Circular": {
        "family": "Flow Circular",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Flow-Rounded": {
        "family": "Flow Rounded",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fondamento": {
        "family": "Fondamento",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fontdiner-Swanky": {
        "family": "Fontdiner Swanky",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Forum": {
        "family": "Forum",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Francois-One": {
        "family": "Francois One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Frank-Ruhl-Libre": {
        "family": "Frank Ruhl Libre",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Fraunces": {
        "family": "Fraunces",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Freckle-Face": {
        "family": "Freckle Face",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fredericka-the-Great": {
        "family": "Fredericka the Great",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fredoka": {
        "family": "Fredoka",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Fredoka-One": {
        "family": "Fredoka One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Freehand": {
        "family": "Freehand",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Fresca": {
        "family": "Fresca",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Frijole": {
        "family": "Frijole",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Fruktur": {
        "family": "Fruktur",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Fugaz-One": {
        "family": "Fugaz One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Fuggles": {
        "family": "Fuggles",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Fuzzy-Bubbles": {
        "family": "Fuzzy Bubbles",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "GFS-Didot": {
        "family": "GFS Didot",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "greek"
        ]
    },
    "GFS-Neohellenic": {
        "family": "GFS Neohellenic",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "greek"
        ]
    },
    "Gabriela": {
        "family": "Gabriela",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin"
        ]
    },
    "Gaegu": {
        "family": "Gaegu",
        "category": "handwriting",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Gafata": {
        "family": "Gafata",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Galada": {
        "family": "Galada",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "bengali",
            "latin"
        ]
    },
    "Galdeano": {
        "family": "Galdeano",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Galindo": {
        "family": "Galindo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Gamja-Flower": {
        "family": "Gamja Flower",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Gayathri": {
        "family": "Gayathri",
        "category": "sans-serif",
        "variants": [
            "100",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "malayalam"
        ]
    },
    "Gelasio": {
        "family": "Gelasio",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gemunu-Libre": {
        "family": "Gemunu Libre",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "sinhala"
        ]
    },
    "Genos": {
        "family": "Genos",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cherokee",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gentium-Basic": {
        "family": "Gentium Basic",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Gentium-Book-Basic": {
        "family": "Gentium Book Basic",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Geo": {
        "family": "Geo",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Georama": {
        "family": "Georama",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Geostar": {
        "family": "Geostar",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Geostar-Fill": {
        "family": "Geostar Fill",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Germania-One": {
        "family": "Germania One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Gideon-Roman": {
        "family": "Gideon Roman",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gidugu": {
        "family": "Gidugu",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Gilda-Display": {
        "family": "Gilda Display",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Girassol": {
        "family": "Girassol",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Give-You-Glory": {
        "family": "Give You Glory",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Glass-Antiqua": {
        "family": "Glass Antiqua",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Glegoo": {
        "family": "Glegoo",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Gloria-Hallelujah": {
        "family": "Gloria Hallelujah",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Glory": {
        "family": "Glory",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gluten": {
        "family": "Gluten",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Goblin-One": {
        "family": "Goblin One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Gochi-Hand": {
        "family": "Gochi Hand",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Goldman": {
        "family": "Goldman",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gorditas": {
        "family": "Gorditas",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Gothic-A1": {
        "family": "Gothic A1",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Gotu": {
        "family": "Gotu",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Goudy-Bookletter-1911": {
        "family": "Goudy Bookletter 1911",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Gowun-Batang": {
        "family": "Gowun Batang",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "korean",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gowun-Dodum": {
        "family": "Gowun Dodum",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Graduate": {
        "family": "Graduate",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Grand-Hotel": {
        "family": "Grand Hotel",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Grandstander": {
        "family": "Grandstander",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Gravitas-One": {
        "family": "Gravitas One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Great-Vibes": {
        "family": "Great Vibes",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Grechen-Fuemen": {
        "family": "Grechen Fuemen",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Grenze": {
        "family": "Grenze",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Grenze-Gotisch": {
        "family": "Grenze Gotisch",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Grey-Qo": {
        "family": "Grey Qo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Griffy": {
        "family": "Griffy",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Gruppo": {
        "family": "Gruppo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Gudea": {
        "family": "Gudea",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Gugi": {
        "family": "Gugi",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Gupter": {
        "family": "Gupter",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Gurajada": {
        "family": "Gurajada",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Gwendolyn": {
        "family": "Gwendolyn",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Habibi": {
        "family": "Habibi",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Hachi-Maru-Pop": {
        "family": "Hachi Maru Pop",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Hahmlet": {
        "family": "Hahmlet",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "korean",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Halant": {
        "family": "Halant",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Hammersmith-One": {
        "family": "Hammersmith One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Hanalei": {
        "family": "Hanalei",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Hanalei-Fill": {
        "family": "Hanalei Fill",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Handlee": {
        "family": "Handlee",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Hanuman": {
        "family": "Hanuman",
        "category": "serif",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Happy-Monkey": {
        "family": "Happy Monkey",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Harmattan": {
        "family": "Harmattan",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Headland-One": {
        "family": "Headland One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Heebo": {
        "family": "Heebo",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "hebrew",
            "latin"
        ]
    },
    "Henny-Penny": {
        "family": "Henny Penny",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Hepta-Slab": {
        "family": "Hepta Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Herr-Von-Muellerhoff": {
        "family": "Herr Von Muellerhoff",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Hi-Melody": {
        "family": "Hi Melody",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Hina-Mincho": {
        "family": "Hina Mincho",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Hind": {
        "family": "Hind",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Hind-Guntur": {
        "family": "Hind Guntur",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "telugu"
        ]
    },
    "Hind-Madurai": {
        "family": "Hind Madurai",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil"
        ]
    },
    "Hind-Siliguri": {
        "family": "Hind Siliguri",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "bengali",
            "latin",
            "latin-ext"
        ]
    },
    "Hind-Vadodara": {
        "family": "Hind Vadodara",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Holtwood-One-SC": {
        "family": "Holtwood One SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Homemade-Apple": {
        "family": "Homemade Apple",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Homenaje": {
        "family": "Homenaje",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Hubballi": {
        "family": "Hubballi",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "kannada",
            "latin",
            "latin-ext"
        ]
    },
    "Hurricane": {
        "family": "Hurricane",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "IBM-Plex-Mono": {
        "family": "IBM Plex Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "IBM-Plex-Sans": {
        "family": "IBM Plex Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "IBM-Plex-Sans-Arabic": {
        "family": "IBM Plex Sans Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "IBM-Plex-Sans-Condensed": {
        "family": "IBM Plex Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "IBM-Plex-Sans-Devanagari": {
        "family": "IBM Plex Sans Devanagari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic-ext",
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "IBM-Plex-Sans-Hebrew": {
        "family": "IBM Plex Sans Hebrew",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic-ext",
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "IBM-Plex-Sans-KR": {
        "family": "IBM Plex Sans KR",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "korean",
            "latin",
            "latin-ext"
        ]
    },
    "IBM-Plex-Sans-Thai": {
        "family": "IBM Plex Sans Thai",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "thai"
        ]
    },
    "IBM-Plex-Sans-Thai-Looped": {
        "family": "IBM Plex Sans Thai Looped",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "thai"
        ]
    },
    "IBM-Plex-Serif": {
        "family": "IBM Plex Serif",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "IM-Fell-DW-Pica": {
        "family": "IM Fell DW Pica",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-DW-Pica-SC": {
        "family": "IM Fell DW Pica SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-Double-Pica": {
        "family": "IM Fell Double Pica",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-Double-Pica-SC": {
        "family": "IM Fell Double Pica SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-English": {
        "family": "IM Fell English",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-English-SC": {
        "family": "IM Fell English SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-French-Canon": {
        "family": "IM Fell French Canon",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-French-Canon-SC": {
        "family": "IM Fell French Canon SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-Great-Primer": {
        "family": "IM Fell Great Primer",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "IM-Fell-Great-Primer-SC": {
        "family": "IM Fell Great Primer SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Ibarra-Real-Nova": {
        "family": "Ibarra Real Nova",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Iceberg": {
        "family": "Iceberg",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Iceland": {
        "family": "Iceland",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Imbue": {
        "family": "Imbue",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Imperial-Script": {
        "family": "Imperial Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Imprima": {
        "family": "Imprima",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Inconsolata": {
        "family": "Inconsolata",
        "category": "monospace",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Inder": {
        "family": "Inder",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Indie-Flower": {
        "family": "Indie Flower",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Inika": {
        "family": "Inika",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Inknut-Antiqua": {
        "family": "Inknut Antiqua",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Inria-Sans": {
        "family": "Inria Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Inria-Serif": {
        "family": "Inria Serif",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Inspiration": {
        "family": "Inspiration",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Inter": {
        "family": "Inter",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Irish-Grover": {
        "family": "Irish Grover",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Island-Moments": {
        "family": "Island Moments",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Istok-Web": {
        "family": "Istok Web",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Italiana": {
        "family": "Italiana",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Italianno": {
        "family": "Italianno",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Itim": {
        "family": "Itim",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Jacques-Francois": {
        "family": "Jacques Francois",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Jacques-Francois-Shadow": {
        "family": "Jacques Francois Shadow",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Jaldi": {
        "family": "Jaldi",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "JetBrains-Mono": {
        "family": "JetBrains Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Jim-Nightshade": {
        "family": "Jim Nightshade",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Jockey-One": {
        "family": "Jockey One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Jolly-Lodger": {
        "family": "Jolly Lodger",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Jomhuria": {
        "family": "Jomhuria",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Jomolhari": {
        "family": "Jomolhari",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "tibetan"
        ]
    },
    "Josefin-Sans": {
        "family": "Josefin Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Josefin-Slab": {
        "family": "Josefin Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Jost": {
        "family": "Jost",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Joti-One": {
        "family": "Joti One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Jua": {
        "family": "Jua",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Judson": {
        "family": "Judson",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Julee": {
        "family": "Julee",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Julius-Sans-One": {
        "family": "Julius Sans One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Junge": {
        "family": "Junge",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Jura": {
        "family": "Jura",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "kayah-li",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Just-Another-Hand": {
        "family": "Just Another Hand",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Just-Me-Again-Down-Here": {
        "family": "Just Me Again Down Here",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "K2D": {
        "family": "K2D",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Kadwa": {
        "family": "Kadwa",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin"
        ]
    },
    "Kaisei-Decol": {
        "family": "Kaisei Decol",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kaisei-HarunoUmi": {
        "family": "Kaisei HarunoUmi",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kaisei-Opti": {
        "family": "Kaisei Opti",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kaisei-Tokumin": {
        "family": "Kaisei Tokumin",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kalam": {
        "family": "Kalam",
        "category": "handwriting",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Kameron": {
        "family": "Kameron",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Kanit": {
        "family": "Kanit",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Kantumruy": {
        "family": "Kantumruy",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Karantina": {
        "family": "Karantina",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Karla": {
        "family": "Karla",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Karma": {
        "family": "Karma",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Katibeh": {
        "family": "Katibeh",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Kaushan-Script": {
        "family": "Kaushan Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kavivanar": {
        "family": "Kavivanar",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil"
        ]
    },
    "Kavoon": {
        "family": "Kavoon",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kdam-Thmor": {
        "family": "Kdam Thmor",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Keania-One": {
        "family": "Keania One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kelly-Slab": {
        "family": "Kelly Slab",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Kenia": {
        "family": "Kenia",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Khand": {
        "family": "Khand",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Khmer": {
        "family": "Khmer",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Khula": {
        "family": "Khula",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Kings": {
        "family": "Kings",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Kirang-Haerang": {
        "family": "Kirang Haerang",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Kite-One": {
        "family": "Kite One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Kiwi-Maru": {
        "family": "Kiwi Maru",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Klee-One": {
        "family": "Klee One",
        "category": "handwriting",
        "variants": [
            "400",
            "600"
        ],
        "subsets": [
            "cyrillic",
            "greek-ext",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Knewave": {
        "family": "Knewave",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "KoHo": {
        "family": "KoHo",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Kodchasan": {
        "family": "Kodchasan",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Koh-Santepheap": {
        "family": "Koh Santepheap",
        "category": "display",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Kolker-Brush": {
        "family": "Kolker Brush",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Kosugi": {
        "family": "Kosugi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kosugi-Maru": {
        "family": "Kosugi Maru",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Kotta-One": {
        "family": "Kotta One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Koulen": {
        "family": "Koulen",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Kranky": {
        "family": "Kranky",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Kreon": {
        "family": "Kreon",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kristi": {
        "family": "Kristi",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Krona-One": {
        "family": "Krona One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Krub": {
        "family": "Krub",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Kufam": {
        "family": "Kufam",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Kulim-Park": {
        "family": "Kulim Park",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kumar-One": {
        "family": "Kumar One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Kumar-One-Outline": {
        "family": "Kumar One Outline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Kumbh-Sans": {
        "family": "Kumbh Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Kurale": {
        "family": "Kurale",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "La-Belle-Aurore": {
        "family": "La Belle Aurore",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Lacquer": {
        "family": "Lacquer",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Laila": {
        "family": "Laila",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Lakki-Reddy": {
        "family": "Lakki Reddy",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Lalezar": {
        "family": "Lalezar",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lancelot": {
        "family": "Lancelot",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Langar": {
        "family": "Langar",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gurmukhi",
            "latin",
            "latin-ext"
        ]
    },
    "Lateef": {
        "family": "Lateef",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Lato": {
        "family": "Lato",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "League-Gothic": {
        "family": "League Gothic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "League-Script": {
        "family": "League Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "League-Spartan": {
        "family": "League Spartan",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Leckerli-One": {
        "family": "Leckerli One",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Ledger": {
        "family": "Ledger",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Lekton": {
        "family": "Lekton",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Lemon": {
        "family": "Lemon",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Lemonada": {
        "family": "Lemonada",
        "category": "display",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend": {
        "family": "Lexend",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Deca": {
        "family": "Lexend Deca",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Exa": {
        "family": "Lexend Exa",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Giga": {
        "family": "Lexend Giga",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Mega": {
        "family": "Lexend Mega",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Peta": {
        "family": "Lexend Peta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Tera": {
        "family": "Lexend Tera",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lexend-Zetta": {
        "family": "Lexend Zetta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Libre-Barcode-128": {
        "family": "Libre Barcode 128",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-128-Text": {
        "family": "Libre Barcode 128 Text",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-39": {
        "family": "Libre Barcode 39",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-39-Extended": {
        "family": "Libre Barcode 39 Extended",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-39-Extended-Text": {
        "family": "Libre Barcode 39 Extended Text",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-39-Text": {
        "family": "Libre Barcode 39 Text",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Barcode-EAN13-Text": {
        "family": "Libre Barcode EAN13 Text",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Libre-Baskerville": {
        "family": "Libre Baskerville",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Libre-Caslon-Display": {
        "family": "Libre Caslon Display",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Libre-Caslon-Text": {
        "family": "Libre Caslon Text",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Libre-Franklin": {
        "family": "Libre Franklin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Licorice": {
        "family": "Licorice",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Life-Savers": {
        "family": "Life Savers",
        "category": "display",
        "variants": [
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Lilita-One": {
        "family": "Lilita One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Lily-Script-One": {
        "family": "Lily Script One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Limelight": {
        "family": "Limelight",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Linden-Hill": {
        "family": "Linden Hill",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Literata": {
        "family": "Literata",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Liu-Jian-Mao-Cao": {
        "family": "Liu Jian Mao Cao",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Livvic": {
        "family": "Livvic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lobster": {
        "family": "Lobster",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Lobster-Two": {
        "family": "Lobster Two",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Londrina-Outline": {
        "family": "Londrina Outline",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Londrina-Shadow": {
        "family": "Londrina Shadow",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Londrina-Sketch": {
        "family": "Londrina Sketch",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Londrina-Solid": {
        "family": "Londrina Solid",
        "category": "display",
        "variants": [
            "100",
            "300",
            "400",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Long-Cang": {
        "family": "Long Cang",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Lora": {
        "family": "Lora",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Love-Light": {
        "family": "Love Light",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Love-Ya-Like-A-Sister": {
        "family": "Love Ya Like A Sister",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Loved-by-the-King": {
        "family": "Loved by the King",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Lovers-Quarrel": {
        "family": "Lovers Quarrel",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Luckiest-Guy": {
        "family": "Luckiest Guy",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Lusitana": {
        "family": "Lusitana",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Lustria": {
        "family": "Lustria",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Luxurious-Roman": {
        "family": "Luxurious Roman",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Luxurious-Script": {
        "family": "Luxurious Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-1": {
        "family": "M PLUS 1",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-1-Code": {
        "family": "M PLUS 1 Code",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-1p": {
        "family": "M PLUS 1p",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-2": {
        "family": "M PLUS 2",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-Code-Latin": {
        "family": "M PLUS Code Latin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "M-PLUS-Rounded-1c": {
        "family": "M PLUS Rounded 1c",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Ma-Shan-Zheng": {
        "family": "Ma Shan Zheng",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Macondo": {
        "family": "Macondo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Macondo-Swash-Caps": {
        "family": "Macondo Swash Caps",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mada": {
        "family": "Mada",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Magra": {
        "family": "Magra",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Maiden-Orange": {
        "family": "Maiden Orange",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Maitree": {
        "family": "Maitree",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Major-Mono-Display": {
        "family": "Major Mono Display",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Mako": {
        "family": "Mako",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mali": {
        "family": "Mali",
        "category": "handwriting",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Mallanna": {
        "family": "Mallanna",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Mandali": {
        "family": "Mandali",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Manjari": {
        "family": "Manjari",
        "category": "sans-serif",
        "variants": [
            "100",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "malayalam"
        ]
    },
    "Manrope": {
        "family": "Manrope",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Mansalva": {
        "family": "Mansalva",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Manuale": {
        "family": "Manuale",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Marcellus": {
        "family": "Marcellus",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Marcellus-SC": {
        "family": "Marcellus SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Marck-Script": {
        "family": "Marck Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Margarine": {
        "family": "Margarine",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Markazi-Text": {
        "family": "Markazi Text",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Marko-One": {
        "family": "Marko One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Marmelad": {
        "family": "Marmelad",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Martel": {
        "family": "Martel",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Martel-Sans": {
        "family": "Martel Sans",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Marvel": {
        "family": "Marvel",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mate": {
        "family": "Mate",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mate-SC": {
        "family": "Mate SC",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Maven-Pro": {
        "family": "Maven Pro",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "McLaren": {
        "family": "McLaren",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mea-Culpa": {
        "family": "Mea Culpa",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Meddon": {
        "family": "Meddon",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "MedievalSharp": {
        "family": "MedievalSharp",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Medula-One": {
        "family": "Medula One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Meera-Inimai": {
        "family": "Meera Inimai",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "tamil"
        ]
    },
    "Megrim": {
        "family": "Megrim",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Meie-Script": {
        "family": "Meie Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Meow-Script": {
        "family": "Meow Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Merienda": {
        "family": "Merienda",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Merienda-One": {
        "family": "Merienda One",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Merriweather": {
        "family": "Merriweather",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Merriweather-Sans": {
        "family": "Merriweather Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Metal": {
        "family": "Metal",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Metal-Mania": {
        "family": "Metal Mania",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Metamorphous": {
        "family": "Metamorphous",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Metrophobic": {
        "family": "Metrophobic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Michroma": {
        "family": "Michroma",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Milonga": {
        "family": "Milonga",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Miltonian": {
        "family": "Miltonian",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Miltonian-Tattoo": {
        "family": "Miltonian Tattoo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mina": {
        "family": "Mina",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "bengali",
            "latin",
            "latin-ext"
        ]
    },
    "Miniver": {
        "family": "Miniver",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Miriam-Libre": {
        "family": "Miriam Libre",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Mirza": {
        "family": "Mirza",
        "category": "display",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Miss-Fajardose": {
        "family": "Miss Fajardose",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mitr": {
        "family": "Mitr",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Mochiy-Pop-One": {
        "family": "Mochiy Pop One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Mochiy-Pop-P-One": {
        "family": "Mochiy Pop P One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Modak": {
        "family": "Modak",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Modern-Antiqua": {
        "family": "Modern Antiqua",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mogra": {
        "family": "Mogra",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Mohave": {
        "family": "Mohave",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Molengo": {
        "family": "Molengo",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Molle": {
        "family": "Molle",
        "category": "handwriting",
        "variants": [],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Monda": {
        "family": "Monda",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Monofett": {
        "family": "Monofett",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Monoton": {
        "family": "Monoton",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Monsieur-La-Doulaise": {
        "family": "Monsieur La Doulaise",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Montaga": {
        "family": "Montaga",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Montagu-Slab": {
        "family": "Montagu Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "MonteCarlo": {
        "family": "MonteCarlo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Montez": {
        "family": "Montez",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Montserrat": {
        "family": "Montserrat",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Montserrat-Alternates": {
        "family": "Montserrat Alternates",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Montserrat-Subrayada": {
        "family": "Montserrat Subrayada",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Moo-Lah-Lah": {
        "family": "Moo Lah Lah",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Moon-Dance": {
        "family": "Moon Dance",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Moul": {
        "family": "Moul",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Moulpali": {
        "family": "Moulpali",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Mountains-of-Christmas": {
        "family": "Mountains of Christmas",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Mouse-Memoirs": {
        "family": "Mouse Memoirs",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mr-Bedfort": {
        "family": "Mr Bedfort",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mr-Dafoe": {
        "family": "Mr Dafoe",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mr-De-Haviland": {
        "family": "Mr De Haviland",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mrs-Saint-Delafield": {
        "family": "Mrs Saint Delafield",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mrs-Sheppards": {
        "family": "Mrs Sheppards",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Mukta": {
        "family": "Mukta",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Mukta-Mahee": {
        "family": "Mukta Mahee",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "gurmukhi",
            "latin",
            "latin-ext"
        ]
    },
    "Mukta-Malar": {
        "family": "Mukta Malar",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil"
        ]
    },
    "Mukta-Vaani": {
        "family": "Mukta Vaani",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Mulish": {
        "family": "Mulish",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Murecho": {
        "family": "Murecho",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "MuseoModerno": {
        "family": "MuseoModerno",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Mystery-Quest": {
        "family": "Mystery Quest",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "NTR": {
        "family": "NTR",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Nanum-Brush-Script": {
        "family": "Nanum Brush Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Nanum-Gothic": {
        "family": "Nanum Gothic",
        "category": "sans-serif",
        "variants": [
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Nanum-Gothic-Coding": {
        "family": "Nanum Gothic Coding",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Nanum-Myeongjo": {
        "family": "Nanum Myeongjo",
        "category": "serif",
        "variants": [
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Nanum-Pen-Script": {
        "family": "Nanum Pen Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Neonderthaw": {
        "family": "Neonderthaw",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Nerko-One": {
        "family": "Nerko One",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Neucha": {
        "family": "Neucha",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin"
        ]
    },
    "Neuton": {
        "family": "Neuton",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "New-Rocker": {
        "family": "New Rocker",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "New-Tegomin": {
        "family": "New Tegomin",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "News-Cycle": {
        "family": "News Cycle",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Newsreader": {
        "family": "Newsreader",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Niconne": {
        "family": "Niconne",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Niramit": {
        "family": "Niramit",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Nixie-One": {
        "family": "Nixie One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nobile": {
        "family": "Nobile",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Nokora": {
        "family": "Nokora",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Norican": {
        "family": "Norican",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Nosifer": {
        "family": "Nosifer",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Notable": {
        "family": "Notable",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nothing-You-Could-Do": {
        "family": "Nothing You Could Do",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Noticia-Text": {
        "family": "Noticia Text",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Kufi-Arabic": {
        "family": "Noto Kufi Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "arabic"
        ]
    },
    "Noto-Music": {
        "family": "Noto Music",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "music"
        ]
    },
    "Noto-Naskh-Arabic": {
        "family": "Noto Naskh Arabic",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic"
        ]
    },
    "Noto-Nastaliq-Urdu": {
        "family": "Noto Nastaliq Urdu",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "arabic"
        ]
    },
    "Noto-Rashi-Hebrew": {
        "family": "Noto Rashi Hebrew",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "hebrew"
        ]
    },
    "Noto-Sans": {
        "family": "Noto Sans",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "devanagari",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Sans-Adlam": {
        "family": "Noto Sans Adlam",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "adlam"
        ]
    },
    "Noto-Sans-Adlam-Unjoined": {
        "family": "Noto Sans Adlam Unjoined",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "adlam"
        ]
    },
    "Noto-Sans-Anatolian-Hieroglyphs": {
        "family": "Noto Sans Anatolian Hieroglyphs",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "anatolian-hieroglyphs"
        ]
    },
    "Noto-Sans-Arabic": {
        "family": "Noto Sans Arabic",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "arabic"
        ]
    },
    "Noto-Sans-Armenian": {
        "family": "Noto Sans Armenian",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "armenian"
        ]
    },
    "Noto-Sans-Avestan": {
        "family": "Noto Sans Avestan",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "avestan"
        ]
    },
    "Noto-Sans-Balinese": {
        "family": "Noto Sans Balinese",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "balinese"
        ]
    },
    "Noto-Sans-Bamum": {
        "family": "Noto Sans Bamum",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "bamum"
        ]
    },
    "Noto-Sans-Bassa-Vah": {
        "family": "Noto Sans Bassa Vah",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "bassa-vah"
        ]
    },
    "Noto-Sans-Batak": {
        "family": "Noto Sans Batak",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "batak"
        ]
    },
    "Noto-Sans-Bengali": {
        "family": "Noto Sans Bengali",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "bengali"
        ]
    },
    "Noto-Sans-Bhaiksuki": {
        "family": "Noto Sans Bhaiksuki",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "bhaiksuki"
        ]
    },
    "Noto-Sans-Brahmi": {
        "family": "Noto Sans Brahmi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "brahmi"
        ]
    },
    "Noto-Sans-Buginese": {
        "family": "Noto Sans Buginese",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "buginese"
        ]
    },
    "Noto-Sans-Buhid": {
        "family": "Noto Sans Buhid",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "buhid"
        ]
    },
    "Noto-Sans-Canadian-Aboriginal": {
        "family": "Noto Sans Canadian Aboriginal",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "canadian-aboriginal"
        ]
    },
    "Noto-Sans-Carian": {
        "family": "Noto Sans Carian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "carian"
        ]
    },
    "Noto-Sans-Caucasian-Albanian": {
        "family": "Noto Sans Caucasian Albanian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "caucasian-albanian"
        ]
    },
    "Noto-Sans-Chakma": {
        "family": "Noto Sans Chakma",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "chakma"
        ]
    },
    "Noto-Sans-Cham": {
        "family": "Noto Sans Cham",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cham"
        ]
    },
    "Noto-Sans-Cherokee": {
        "family": "Noto Sans Cherokee",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cherokee"
        ]
    },
    "Noto-Sans-Coptic": {
        "family": "Noto Sans Coptic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "coptic"
        ]
    },
    "Noto-Sans-Cuneiform": {
        "family": "Noto Sans Cuneiform",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cuneiform"
        ]
    },
    "Noto-Sans-Cypriot": {
        "family": "Noto Sans Cypriot",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cypriot"
        ]
    },
    "Noto-Sans-Deseret": {
        "family": "Noto Sans Deseret",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "deseret"
        ]
    },
    "Noto-Sans-Devanagari": {
        "family": "Noto Sans Devanagari",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari"
        ]
    },
    "Noto-Sans-Display": {
        "family": "Noto Sans Display",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Sans-Duployan": {
        "family": "Noto Sans Duployan",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "duployan"
        ]
    },
    "Noto-Sans-Egyptian-Hieroglyphs": {
        "family": "Noto Sans Egyptian Hieroglyphs",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "egyptian-hieroglyphs"
        ]
    },
    "Noto-Sans-Elbasan": {
        "family": "Noto Sans Elbasan",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "elbasan"
        ]
    },
    "Noto-Sans-Elymaic": {
        "family": "Noto Sans Elymaic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "elymaic"
        ]
    },
    "Noto-Sans-Georgian": {
        "family": "Noto Sans Georgian",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "georgian"
        ]
    },
    "Noto-Sans-Glagolitic": {
        "family": "Noto Sans Glagolitic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "glagolitic"
        ]
    },
    "Noto-Sans-Gothic": {
        "family": "Noto Sans Gothic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "gothic"
        ]
    },
    "Noto-Sans-Grantha": {
        "family": "Noto Sans Grantha",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "grantha"
        ]
    },
    "Noto-Sans-Gujarati": {
        "family": "Noto Sans Gujarati",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "gujarati"
        ]
    },
    "Noto-Sans-Gunjala-Gondi": {
        "family": "Noto Sans Gunjala Gondi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "gunjala-gondi"
        ]
    },
    "Noto-Sans-Gurmukhi": {
        "family": "Noto Sans Gurmukhi",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "gurmukhi"
        ]
    },
    "Noto-Sans-HK": {
        "family": "Noto Sans HK",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "chinese-hongkong",
            "latin"
        ]
    },
    "Noto-Sans-Hanifi-Rohingya": {
        "family": "Noto Sans Hanifi Rohingya",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "hanifi-rohingya"
        ]
    },
    "Noto-Sans-Hanunoo": {
        "family": "Noto Sans Hanunoo",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hanunoo"
        ]
    },
    "Noto-Sans-Hatran": {
        "family": "Noto Sans Hatran",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hatran"
        ]
    },
    "Noto-Sans-Hebrew": {
        "family": "Noto Sans Hebrew",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "hebrew"
        ]
    },
    "Noto-Sans-Imperial-Aramaic": {
        "family": "Noto Sans Imperial Aramaic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "imperial-aramaic"
        ]
    },
    "Noto-Sans-Indic-Siyaq-Numbers": {
        "family": "Noto Sans Indic Siyaq Numbers",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "indic-siyaq-numbers"
        ]
    },
    "Noto-Sans-Inscriptional-Pahlavi": {
        "family": "Noto Sans Inscriptional Pahlavi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "inscriptional-pahlavi"
        ]
    },
    "Noto-Sans-Inscriptional-Parthian": {
        "family": "Noto Sans Inscriptional Parthian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "inscriptional-parthian"
        ]
    },
    "Noto-Sans-JP": {
        "family": "Noto Sans JP",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Noto-Sans-Javanese": {
        "family": "Noto Sans Javanese",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "javanese"
        ]
    },
    "Noto-Sans-KR": {
        "family": "Noto Sans KR",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Noto-Sans-Kaithi": {
        "family": "Noto Sans Kaithi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "kaithi"
        ]
    },
    "Noto-Sans-Kannada": {
        "family": "Noto Sans Kannada",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "kannada"
        ]
    },
    "Noto-Sans-Kayah-Li": {
        "family": "Noto Sans Kayah Li",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "kayah-li"
        ]
    },
    "Noto-Sans-Kharoshthi": {
        "family": "Noto Sans Kharoshthi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "kharoshthi"
        ]
    },
    "Noto-Sans-Khmer": {
        "family": "Noto Sans Khmer",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Noto-Sans-Khojki": {
        "family": "Noto Sans Khojki",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "khojki"
        ]
    },
    "Noto-Sans-Khudawadi": {
        "family": "Noto Sans Khudawadi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "khudawadi"
        ]
    },
    "Noto-Sans-Lao": {
        "family": "Noto Sans Lao",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "lao"
        ]
    },
    "Noto-Sans-Lepcha": {
        "family": "Noto Sans Lepcha",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "lepcha"
        ]
    },
    "Noto-Sans-Limbu": {
        "family": "Noto Sans Limbu",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "limbu"
        ]
    },
    "Noto-Sans-Linear-A": {
        "family": "Noto Sans Linear A",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "linear-a"
        ]
    },
    "Noto-Sans-Linear-B": {
        "family": "Noto Sans Linear B",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "linear-b"
        ]
    },
    "Noto-Sans-Lisu": {
        "family": "Noto Sans Lisu",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "lisu"
        ]
    },
    "Noto-Sans-Lycian": {
        "family": "Noto Sans Lycian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "lycian"
        ]
    },
    "Noto-Sans-Lydian": {
        "family": "Noto Sans Lydian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "lydian"
        ]
    },
    "Noto-Sans-Mahajani": {
        "family": "Noto Sans Mahajani",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "mahajani"
        ]
    },
    "Noto-Sans-Malayalam": {
        "family": "Noto Sans Malayalam",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "malayalam"
        ]
    },
    "Noto-Sans-Mandaic": {
        "family": "Noto Sans Mandaic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "mandaic"
        ]
    },
    "Noto-Sans-Manichaean": {
        "family": "Noto Sans Manichaean",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "manichaean"
        ]
    },
    "Noto-Sans-Marchen": {
        "family": "Noto Sans Marchen",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "marchen"
        ]
    },
    "Noto-Sans-Masaram-Gondi": {
        "family": "Noto Sans Masaram Gondi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "masaram-gondi"
        ]
    },
    "Noto-Sans-Math": {
        "family": "Noto Sans Math",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "math"
        ]
    },
    "Noto-Sans-Mayan-Numerals": {
        "family": "Noto Sans Mayan Numerals",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "mayan-numerals"
        ]
    },
    "Noto-Sans-Medefaidrin": {
        "family": "Noto Sans Medefaidrin",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "medefaidrin"
        ]
    },
    "Noto-Sans-Meetei-Mayek": {
        "family": "Noto Sans Meetei Mayek",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "meetei-mayek"
        ]
    },
    "Noto-Sans-Meroitic": {
        "family": "Noto Sans Meroitic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "meroitic"
        ]
    },
    "Noto-Sans-Miao": {
        "family": "Noto Sans Miao",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "miao"
        ]
    },
    "Noto-Sans-Modi": {
        "family": "Noto Sans Modi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "modi"
        ]
    },
    "Noto-Sans-Mongolian": {
        "family": "Noto Sans Mongolian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "mongolian"
        ]
    },
    "Noto-Sans-Mono": {
        "family": "Noto Sans Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Sans-Mro": {
        "family": "Noto Sans Mro",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "mro"
        ]
    },
    "Noto-Sans-Multani": {
        "family": "Noto Sans Multani",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "multani"
        ]
    },
    "Noto-Sans-Myanmar": {
        "family": "Noto Sans Myanmar",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "myanmar"
        ]
    },
    "Noto-Sans-N-Ko": {
        "family": "Noto Sans N Ko",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "nko"
        ]
    },
    "Noto-Sans-Nabataean": {
        "family": "Noto Sans Nabataean",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "nabataean"
        ]
    },
    "Noto-Sans-New-Tai-Lue": {
        "family": "Noto Sans New Tai Lue",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "new-tai-lue"
        ]
    },
    "Noto-Sans-Newa": {
        "family": "Noto Sans Newa",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "newa"
        ]
    },
    "Noto-Sans-Nushu": {
        "family": "Noto Sans Nushu",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "nushu"
        ]
    },
    "Noto-Sans-Ogham": {
        "family": "Noto Sans Ogham",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "ogham"
        ]
    },
    "Noto-Sans-Ol-Chiki": {
        "family": "Noto Sans Ol Chiki",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "ol-chiki"
        ]
    },
    "Noto-Sans-Old-Hungarian": {
        "family": "Noto Sans Old Hungarian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-hungarian"
        ]
    },
    "Noto-Sans-Old-Italic": {
        "family": "Noto Sans Old Italic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-italic"
        ]
    },
    "Noto-Sans-Old-North-Arabian": {
        "family": "Noto Sans Old North Arabian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-north-arabian"
        ]
    },
    "Noto-Sans-Old-Permic": {
        "family": "Noto Sans Old Permic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-permic"
        ]
    },
    "Noto-Sans-Old-Persian": {
        "family": "Noto Sans Old Persian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-persian"
        ]
    },
    "Noto-Sans-Old-Sogdian": {
        "family": "Noto Sans Old Sogdian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-sogdian"
        ]
    },
    "Noto-Sans-Old-South-Arabian": {
        "family": "Noto Sans Old South Arabian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-south-arabian"
        ]
    },
    "Noto-Sans-Old-Turkic": {
        "family": "Noto Sans Old Turkic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "old-turkic"
        ]
    },
    "Noto-Sans-Oriya": {
        "family": "Noto Sans Oriya",
        "category": "sans-serif",
        "variants": [
            "100",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "oriya"
        ]
    },
    "Noto-Sans-Osage": {
        "family": "Noto Sans Osage",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "osage"
        ]
    },
    "Noto-Sans-Osmanya": {
        "family": "Noto Sans Osmanya",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "osmanya"
        ]
    },
    "Noto-Sans-Pahawh-Hmong": {
        "family": "Noto Sans Pahawh Hmong",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "pahawh-hmong"
        ]
    },
    "Noto-Sans-Palmyrene": {
        "family": "Noto Sans Palmyrene",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "palmyrene"
        ]
    },
    "Noto-Sans-Pau-Cin-Hau": {
        "family": "Noto Sans Pau Cin Hau",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "pau-cin-hau"
        ]
    },
    "Noto-Sans-Phags-Pa": {
        "family": "Noto Sans Phags Pa",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "phags-pa"
        ]
    },
    "Noto-Sans-Phoenician": {
        "family": "Noto Sans Phoenician",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "phoenician"
        ]
    },
    "Noto-Sans-Psalter-Pahlavi": {
        "family": "Noto Sans Psalter Pahlavi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "psalter-pahlavi"
        ]
    },
    "Noto-Sans-Rejang": {
        "family": "Noto Sans Rejang",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "rejang"
        ]
    },
    "Noto-Sans-Runic": {
        "family": "Noto Sans Runic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "runic"
        ]
    },
    "Noto-Sans-SC": {
        "family": "Noto Sans SC",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Noto-Sans-Samaritan": {
        "family": "Noto Sans Samaritan",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "samaritan"
        ]
    },
    "Noto-Sans-Saurashtra": {
        "family": "Noto Sans Saurashtra",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "saurashtra"
        ]
    },
    "Noto-Sans-Sharada": {
        "family": "Noto Sans Sharada",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "sharada"
        ]
    },
    "Noto-Sans-Shavian": {
        "family": "Noto Sans Shavian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "shavian"
        ]
    },
    "Noto-Sans-Siddham": {
        "family": "Noto Sans Siddham",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "siddham"
        ]
    },
    "Noto-Sans-Sinhala": {
        "family": "Noto Sans Sinhala",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "sinhala"
        ]
    },
    "Noto-Sans-Sogdian": {
        "family": "Noto Sans Sogdian",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "sogdian"
        ]
    },
    "Noto-Sans-Sora-Sompeng": {
        "family": "Noto Sans Sora Sompeng",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "sora-sompeng"
        ]
    },
    "Noto-Sans-Soyombo": {
        "family": "Noto Sans Soyombo",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "soyombo"
        ]
    },
    "Noto-Sans-Sundanese": {
        "family": "Noto Sans Sundanese",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "sundanese"
        ]
    },
    "Noto-Sans-Syloti-Nagri": {
        "family": "Noto Sans Syloti Nagri",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "syloti-nagri"
        ]
    },
    "Noto-Sans-Symbols": {
        "family": "Noto Sans Symbols",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "symbols"
        ]
    },
    "Noto-Sans-Symbols-2": {
        "family": "Noto Sans Symbols 2",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "symbols"
        ]
    },
    "Noto-Sans-Syriac": {
        "family": "Noto Sans Syriac",
        "category": "sans-serif",
        "variants": [
            "100",
            "400",
            "900"
        ],
        "subsets": [
            "syriac"
        ]
    },
    "Noto-Sans-TC": {
        "family": "Noto Sans TC",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "chinese-traditional",
            "latin"
        ]
    },
    "Noto-Sans-Tagalog": {
        "family": "Noto Sans Tagalog",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tagalog"
        ]
    },
    "Noto-Sans-Tagbanwa": {
        "family": "Noto Sans Tagbanwa",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tagbanwa"
        ]
    },
    "Noto-Sans-Tai-Le": {
        "family": "Noto Sans Tai Le",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tai-le"
        ]
    },
    "Noto-Sans-Tai-Tham": {
        "family": "Noto Sans Tai Tham",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "tai-tham"
        ]
    },
    "Noto-Sans-Tai-Viet": {
        "family": "Noto Sans Tai Viet",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tai-viet"
        ]
    },
    "Noto-Sans-Takri": {
        "family": "Noto Sans Takri",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "takri"
        ]
    },
    "Noto-Sans-Tamil": {
        "family": "Noto Sans Tamil",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "tamil"
        ]
    },
    "Noto-Sans-Tamil-Supplement": {
        "family": "Noto Sans Tamil Supplement",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tamil-supplement"
        ]
    },
    "Noto-Sans-Telugu": {
        "family": "Noto Sans Telugu",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "telugu"
        ]
    },
    "Noto-Sans-Thaana": {
        "family": "Noto Sans Thaana",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "thaana"
        ]
    },
    "Noto-Sans-Thai": {
        "family": "Noto Sans Thai",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "thai"
        ]
    },
    "Noto-Sans-Thai-Looped": {
        "family": "Noto Sans Thai Looped",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "thai"
        ]
    },
    "Noto-Sans-Tifinagh": {
        "family": "Noto Sans Tifinagh",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tifinagh"
        ]
    },
    "Noto-Sans-Tirhuta": {
        "family": "Noto Sans Tirhuta",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tirhuta"
        ]
    },
    "Noto-Sans-Ugaritic": {
        "family": "Noto Sans Ugaritic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "ugaritic"
        ]
    },
    "Noto-Sans-Vai": {
        "family": "Noto Sans Vai",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "vai"
        ]
    },
    "Noto-Sans-Wancho": {
        "family": "Noto Sans Wancho",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "wancho"
        ]
    },
    "Noto-Sans-Warang-Citi": {
        "family": "Noto Sans Warang Citi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "warang-citi"
        ]
    },
    "Noto-Sans-Yi": {
        "family": "Noto Sans Yi",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "yi"
        ]
    },
    "Noto-Sans-Zanabazar-Square": {
        "family": "Noto Sans Zanabazar Square",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "zanabazar-square"
        ]
    },
    "Noto-Serif": {
        "family": "Noto Serif",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Serif-Ahom": {
        "family": "Noto Serif Ahom",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "ahom"
        ]
    },
    "Noto-Serif-Armenian": {
        "family": "Noto Serif Armenian",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "armenian"
        ]
    },
    "Noto-Serif-Balinese": {
        "family": "Noto Serif Balinese",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "balinese"
        ]
    },
    "Noto-Serif-Bengali": {
        "family": "Noto Serif Bengali",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "bengali"
        ]
    },
    "Noto-Serif-Devanagari": {
        "family": "Noto Serif Devanagari",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari"
        ]
    },
    "Noto-Serif-Display": {
        "family": "Noto Serif Display",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Noto-Serif-Dogra": {
        "family": "Noto Serif Dogra",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "dogra"
        ]
    },
    "Noto-Serif-Ethiopic": {
        "family": "Noto Serif Ethiopic",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "ethiopic"
        ]
    },
    "Noto-Serif-Georgian": {
        "family": "Noto Serif Georgian",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "georgian"
        ]
    },
    "Noto-Serif-Grantha": {
        "family": "Noto Serif Grantha",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "grantha"
        ]
    },
    "Noto-Serif-Gujarati": {
        "family": "Noto Serif Gujarati",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "gujarati"
        ]
    },
    "Noto-Serif-Gurmukhi": {
        "family": "Noto Serif Gurmukhi",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "gurmukhi"
        ]
    },
    "Noto-Serif-Hebrew": {
        "family": "Noto Serif Hebrew",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "hebrew"
        ]
    },
    "Noto-Serif-JP": {
        "family": "Noto Serif JP",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Noto-Serif-KR": {
        "family": "Noto Serif KR",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Noto-Serif-Kannada": {
        "family": "Noto Serif Kannada",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "kannada"
        ]
    },
    "Noto-Serif-Khmer": {
        "family": "Noto Serif Khmer",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Noto-Serif-Lao": {
        "family": "Noto Serif Lao",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "lao"
        ]
    },
    "Noto-Serif-Malayalam": {
        "family": "Noto Serif Malayalam",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "malayalam"
        ]
    },
    "Noto-Serif-Myanmar": {
        "family": "Noto Serif Myanmar",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "myanmar"
        ]
    },
    "Noto-Serif-Nyiakeng-Puachue-Hmong": {
        "family": "Noto Serif Nyiakeng Puachue Hmong",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "nyiakeng-puachue-hmong"
        ]
    },
    "Noto-Serif-SC": {
        "family": "Noto Serif SC",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Noto-Serif-Sinhala": {
        "family": "Noto Serif Sinhala",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "sinhala"
        ]
    },
    "Noto-Serif-TC": {
        "family": "Noto Serif TC",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "chinese-traditional",
            "latin"
        ]
    },
    "Noto-Serif-Tamil": {
        "family": "Noto Serif Tamil",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "tamil"
        ]
    },
    "Noto-Serif-Tangut": {
        "family": "Noto Serif Tangut",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "tangut"
        ]
    },
    "Noto-Serif-Telugu": {
        "family": "Noto Serif Telugu",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "telugu"
        ]
    },
    "Noto-Serif-Thai": {
        "family": "Noto Serif Thai",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "thai"
        ]
    },
    "Noto-Serif-Tibetan": {
        "family": "Noto Serif Tibetan",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "tibetan"
        ]
    },
    "Noto-Serif-Yezidi": {
        "family": "Noto Serif Yezidi",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "yezidi"
        ]
    },
    "Noto-Traditional-Nushu": {
        "family": "Noto Traditional Nushu",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "nushu"
        ]
    },
    "Nova-Cut": {
        "family": "Nova Cut",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Flat": {
        "family": "Nova Flat",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Mono": {
        "family": "Nova Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "greek",
            "latin"
        ]
    },
    "Nova-Oval": {
        "family": "Nova Oval",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Round": {
        "family": "Nova Round",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Script": {
        "family": "Nova Script",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Slim": {
        "family": "Nova Slim",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nova-Square": {
        "family": "Nova Square",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Numans": {
        "family": "Numans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Nunito": {
        "family": "Nunito",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Nunito-Sans": {
        "family": "Nunito Sans",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Odibee-Sans": {
        "family": "Odibee Sans",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Odor-Mean-Chey": {
        "family": "Odor Mean Chey",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Offside": {
        "family": "Offside",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Oi": {
        "family": "Oi",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "tamil",
            "vietnamese"
        ]
    },
    "Old-Standard-TT": {
        "family": "Old Standard TT",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Oldenburg": {
        "family": "Oldenburg",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ole": {
        "family": "Ole",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Oleo-Script": {
        "family": "Oleo Script",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Oleo-Script-Swash-Caps": {
        "family": "Oleo Script Swash Caps",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Oooh-Baby": {
        "family": "Oooh Baby",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Open-Sans": {
        "family": "Open Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Open-Sans-Condensed": {
        "family": "Open Sans Condensed",
        "category": "sans-serif",
        "variants": [
            "300",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Oranienbaum": {
        "family": "Oranienbaum",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Orbitron": {
        "family": "Orbitron",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Oregano": {
        "family": "Oregano",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Orelega-One": {
        "family": "Orelega One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Orienta": {
        "family": "Orienta",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Original-Surfer": {
        "family": "Original Surfer",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Oswald": {
        "family": "Oswald",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Otomanopee-One": {
        "family": "Otomanopee One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Outfit": {
        "family": "Outfit",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Over-the-Rainbow": {
        "family": "Over the Rainbow",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Overlock": {
        "family": "Overlock",
        "category": "display",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Overlock-SC": {
        "family": "Overlock SC",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Overpass": {
        "family": "Overpass",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Overpass-Mono": {
        "family": "Overpass Mono",
        "category": "monospace",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Ovo": {
        "family": "Ovo",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Oxanium": {
        "family": "Oxanium",
        "category": "display",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Oxygen": {
        "family": "Oxygen",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Oxygen-Mono": {
        "family": "Oxygen Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "PT-Mono": {
        "family": "PT Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "PT-Sans": {
        "family": "PT Sans",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "PT-Sans-Caption": {
        "family": "PT Sans Caption",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "PT-Sans-Narrow": {
        "family": "PT Sans Narrow",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "PT-Serif": {
        "family": "PT Serif",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "PT-Serif-Caption": {
        "family": "PT Serif Caption",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Pacifico": {
        "family": "Pacifico",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Padauk": {
        "family": "Padauk",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "myanmar"
        ]
    },
    "Palanquin": {
        "family": "Palanquin",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Palanquin-Dark": {
        "family": "Palanquin Dark",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Palette-Mosaic": {
        "family": "Palette Mosaic",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Pangolin": {
        "family": "Pangolin",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Paprika": {
        "family": "Paprika",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Parisienne": {
        "family": "Parisienne",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Passero-One": {
        "family": "Passero One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Passion-One": {
        "family": "Passion One",
        "category": "display",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Passions-Conflict": {
        "family": "Passions Conflict",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Pathway-Gothic-One": {
        "family": "Pathway Gothic One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Patrick-Hand": {
        "family": "Patrick Hand",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Patrick-Hand-SC": {
        "family": "Patrick Hand SC",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Pattaya": {
        "family": "Pattaya",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Patua-One": {
        "family": "Patua One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Pavanam": {
        "family": "Pavanam",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "tamil"
        ]
    },
    "Paytone-One": {
        "family": "Paytone One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Peddana": {
        "family": "Peddana",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Peralta": {
        "family": "Peralta",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Permanent-Marker": {
        "family": "Permanent Marker",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Petemoss": {
        "family": "Petemoss",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Petit-Formal-Script": {
        "family": "Petit Formal Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Petrona": {
        "family": "Petrona",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Philosopher": {
        "family": "Philosopher",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "vietnamese"
        ]
    },
    "Piazzolla": {
        "family": "Piazzolla",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Piedra": {
        "family": "Piedra",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Pinyon-Script": {
        "family": "Pinyon Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Pirata-One": {
        "family": "Pirata One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Plaster": {
        "family": "Plaster",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Play": {
        "family": "Play",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Playball": {
        "family": "Playball",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Playfair-Display": {
        "family": "Playfair Display",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Playfair-Display-SC": {
        "family": "Playfair Display SC",
        "category": "serif",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Podkova": {
        "family": "Podkova",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Poiret-One": {
        "family": "Poiret One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Poller-One": {
        "family": "Poller One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Poly": {
        "family": "Poly",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Pompiere": {
        "family": "Pompiere",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Pontano-Sans": {
        "family": "Pontano Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Poor-Story": {
        "family": "Poor Story",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Poppins": {
        "family": "Poppins",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Port-Lligat-Sans": {
        "family": "Port Lligat Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Port-Lligat-Slab": {
        "family": "Port Lligat Slab",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Potta-One": {
        "family": "Potta One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Pragati-Narrow": {
        "family": "Pragati Narrow",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Praise": {
        "family": "Praise",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Prata": {
        "family": "Prata",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "vietnamese"
        ]
    },
    "Preahvihear": {
        "family": "Preahvihear",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Press-Start-2P": {
        "family": "Press Start 2P",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext"
        ]
    },
    "Pridi": {
        "family": "Pridi",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Princess-Sofia": {
        "family": "Princess Sofia",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Prociono": {
        "family": "Prociono",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Prompt": {
        "family": "Prompt",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Prosto-One": {
        "family": "Prosto One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Proza-Libre": {
        "family": "Proza Libre",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Public-Sans": {
        "family": "Public Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Puppies-Play": {
        "family": "Puppies Play",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Puritan": {
        "family": "Puritan",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Purple-Purse": {
        "family": "Purple Purse",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Qahiri": {
        "family": "Qahiri",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Quando": {
        "family": "Quando",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Quantico": {
        "family": "Quantico",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Quattrocento": {
        "family": "Quattrocento",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Quattrocento-Sans": {
        "family": "Quattrocento Sans",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Questrial": {
        "family": "Questrial",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Quicksand": {
        "family": "Quicksand",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Quintessential": {
        "family": "Quintessential",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Qwigley": {
        "family": "Qwigley",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Qwitcher-Grypen": {
        "family": "Qwitcher Grypen",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Racing-Sans-One": {
        "family": "Racing Sans One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Radley": {
        "family": "Radley",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rajdhani": {
        "family": "Rajdhani",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Rakkas": {
        "family": "Rakkas",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Raleway": {
        "family": "Raleway",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Raleway-Dots": {
        "family": "Raleway Dots",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ramabhadra": {
        "family": "Ramabhadra",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Ramaraja": {
        "family": "Ramaraja",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Rambla": {
        "family": "Rambla",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rammetto-One": {
        "family": "Rammetto One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rampart-One": {
        "family": "Rampart One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Ranchers": {
        "family": "Ranchers",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rancho": {
        "family": "Rancho",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Ranga": {
        "family": "Ranga",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Rasa": {
        "family": "Rasa",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rationale": {
        "family": "Rationale",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Ravi-Prakash": {
        "family": "Ravi Prakash",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Readex-Pro": {
        "family": "Readex Pro",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Recursive": {
        "family": "Recursive",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Red-Hat-Display": {
        "family": "Red Hat Display",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Red-Hat-Mono": {
        "family": "Red Hat Mono",
        "category": "monospace",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Red-Hat-Text": {
        "family": "Red Hat Text",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Red-Rose": {
        "family": "Red Rose",
        "category": "display",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Redacted": {
        "family": "Redacted",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Redacted-Script": {
        "family": "Redacted Script",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Redressed": {
        "family": "Redressed",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Reem-Kufi": {
        "family": "Reem Kufi",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Reenie-Beanie": {
        "family": "Reenie Beanie",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Reggae-One": {
        "family": "Reggae One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Revalia": {
        "family": "Revalia",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rhodium-Libre": {
        "family": "Rhodium Libre",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Ribeye": {
        "family": "Ribeye",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ribeye-Marrow": {
        "family": "Ribeye Marrow",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Righteous": {
        "family": "Righteous",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Risque": {
        "family": "Risque",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Road-Rage": {
        "family": "Road Rage",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Roboto": {
        "family": "Roboto",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Roboto-Condensed": {
        "family": "Roboto Condensed",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Roboto-Mono": {
        "family": "Roboto Mono",
        "category": "monospace",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Roboto-Serif": {
        "family": "Roboto Serif",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Roboto-Slab": {
        "family": "Roboto Slab",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rochester": {
        "family": "Rochester",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Rock-3D": {
        "family": "Rock 3D",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Rock-Salt": {
        "family": "Rock Salt",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "RocknRoll-One": {
        "family": "RocknRoll One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Rokkitt": {
        "family": "Rokkitt",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Romanesco": {
        "family": "Romanesco",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ropa-Sans": {
        "family": "Ropa Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rosario": {
        "family": "Rosario",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rosarivo": {
        "family": "Rosarivo",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rouge-Script": {
        "family": "Rouge Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Rowdies": {
        "family": "Rowdies",
        "category": "display",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rozha-One": {
        "family": "Rozha One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Rubik": {
        "family": "Rubik",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Rubik-Beastly": {
        "family": "Rubik Beastly",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Rubik-Mono-One": {
        "family": "Rubik Mono One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Ruda": {
        "family": "Ruda",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rufina": {
        "family": "Rufina",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ruge-Boogie": {
        "family": "Ruge Boogie",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Ruluko": {
        "family": "Ruluko",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Rum-Raisin": {
        "family": "Rum Raisin",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Ruslan-Display": {
        "family": "Ruslan Display",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Russo-One": {
        "family": "Russo One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Ruthie": {
        "family": "Ruthie",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Rye": {
        "family": "Rye",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "STIX-Two-Text": {
        "family": "STIX Two Text",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Sacramento": {
        "family": "Sacramento",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sahitya": {
        "family": "Sahitya",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin"
        ]
    },
    "Sail": {
        "family": "Sail",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Saira": {
        "family": "Saira",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Saira-Condensed": {
        "family": "Saira Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Saira-Extra-Condensed": {
        "family": "Saira Extra Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Saira-Semi-Condensed": {
        "family": "Saira Semi Condensed",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Saira-Stencil-One": {
        "family": "Saira Stencil One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Salsa": {
        "family": "Salsa",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sanchez": {
        "family": "Sanchez",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sancreek": {
        "family": "Sancreek",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sansita": {
        "family": "Sansita",
        "category": "sans-serif",
        "variants": [
            "400",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sansita-Swashed": {
        "family": "Sansita Swashed",
        "category": "display",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Sarabun": {
        "family": "Sarabun",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Sarala": {
        "family": "Sarala",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Sarina": {
        "family": "Sarina",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sarpanch": {
        "family": "Sarpanch",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Sassy-Frass": {
        "family": "Sassy Frass",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Satisfy": {
        "family": "Satisfy",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sawarabi-Gothic": {
        "family": "Sawarabi Gothic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Sawarabi-Mincho": {
        "family": "Sawarabi Mincho",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Scada": {
        "family": "Scada",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Scheherazade-New": {
        "family": "Scheherazade New",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "arabic",
            "latin",
            "latin-ext"
        ]
    },
    "Schoolbell": {
        "family": "Schoolbell",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Scope-One": {
        "family": "Scope One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Seaweed-Script": {
        "family": "Seaweed Script",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Secular-One": {
        "family": "Secular One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Sedgwick-Ave": {
        "family": "Sedgwick Ave",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Sedgwick-Ave-Display": {
        "family": "Sedgwick Ave Display",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Sen": {
        "family": "Sen",
        "category": "sans-serif",
        "variants": [
            "400",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sevillana": {
        "family": "Sevillana",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Seymour-One": {
        "family": "Seymour One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Shadows-Into-Light": {
        "family": "Shadows Into Light",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Shadows-Into-Light-Two": {
        "family": "Shadows Into Light Two",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Shalimar": {
        "family": "Shalimar",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Shanti": {
        "family": "Shanti",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Share": {
        "family": "Share",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Share-Tech": {
        "family": "Share Tech",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Share-Tech-Mono": {
        "family": "Share Tech Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Shippori-Antique": {
        "family": "Shippori Antique",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Shippori-Antique-B1": {
        "family": "Shippori Antique B1",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Shippori-Mincho": {
        "family": "Shippori Mincho",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Shippori-Mincho-B1": {
        "family": "Shippori Mincho B1",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Shizuru": {
        "family": "Shizuru",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin"
        ]
    },
    "Shojumaru": {
        "family": "Shojumaru",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Short-Stack": {
        "family": "Short Stack",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Shrikhand": {
        "family": "Shrikhand",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "gujarati",
            "latin",
            "latin-ext"
        ]
    },
    "Siemreap": {
        "family": "Siemreap",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer"
        ]
    },
    "Sigmar-One": {
        "family": "Sigmar One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Signika": {
        "family": "Signika",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Signika-Negative": {
        "family": "Signika Negative",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Simonetta": {
        "family": "Simonetta",
        "category": "display",
        "variants": [
            "400",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Single-Day": {
        "family": "Single Day",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean"
        ]
    },
    "Sintony": {
        "family": "Sintony",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sirin-Stencil": {
        "family": "Sirin Stencil",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Six-Caps": {
        "family": "Six Caps",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Skranji": {
        "family": "Skranji",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Slabo-13px": {
        "family": "Slabo 13px",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Slabo-27px": {
        "family": "Slabo 27px",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Slackey": {
        "family": "Slackey",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Smokum": {
        "family": "Smokum",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Smooch": {
        "family": "Smooch",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Smooch-Sans": {
        "family": "Smooch Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Smythe": {
        "family": "Smythe",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sniglet": {
        "family": "Sniglet",
        "category": "display",
        "variants": [
            "400",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Snippet": {
        "family": "Snippet",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Snowburst-One": {
        "family": "Snowburst One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sofadi-One": {
        "family": "Sofadi One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sofia": {
        "family": "Sofia",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Solway": {
        "family": "Solway",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "700",
            "800"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Song-Myung": {
        "family": "Song Myung",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Sonsie-One": {
        "family": "Sonsie One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sora": {
        "family": "Sora",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sorts-Mill-Goudy": {
        "family": "Sorts Mill Goudy",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Source-Code-Pro": {
        "family": "Source Code Pro",
        "category": "monospace",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Source-Sans-3": {
        "family": "Source Sans 3",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Source-Sans-Pro": {
        "family": "Source Sans Pro",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Source-Serif-4": {
        "family": "Source Serif 4",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Source-Serif-Pro": {
        "family": "Source Serif Pro",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Space-Grotesk": {
        "family": "Space Grotesk",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Space-Mono": {
        "family": "Space Mono",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Spartan": {
        "family": "Spartan",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Special-Elite": {
        "family": "Special Elite",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Spectral": {
        "family": "Spectral",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Spectral-SC": {
        "family": "Spectral SC",
        "category": "serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Spicy-Rice": {
        "family": "Spicy Rice",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Spinnaker": {
        "family": "Spinnaker",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Spirax": {
        "family": "Spirax",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Spline-Sans": {
        "family": "Spline Sans",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Squada-One": {
        "family": "Squada One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sree-Krushnadevaraya": {
        "family": "Sree Krushnadevaraya",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Sriracha": {
        "family": "Sriracha",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Srisakdi": {
        "family": "Srisakdi",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Staatliches": {
        "family": "Staatliches",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Stalemate": {
        "family": "Stalemate",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Stalinist-One": {
        "family": "Stalinist One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Stardos-Stencil": {
        "family": "Stardos Stencil",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Stick": {
        "family": "Stick",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Stick-No-Bills": {
        "family": "Stick No Bills",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "sinhala"
        ]
    },
    "Stint-Ultra-Condensed": {
        "family": "Stint Ultra Condensed",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Stint-Ultra-Expanded": {
        "family": "Stint Ultra Expanded",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Stoke": {
        "family": "Stoke",
        "category": "serif",
        "variants": [
            "300",
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Strait": {
        "family": "Strait",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Style-Script": {
        "family": "Style Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Stylish": {
        "family": "Stylish",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Sue-Ellen-Francisco": {
        "family": "Sue Ellen Francisco",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Suez-One": {
        "family": "Suez One",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext"
        ]
    },
    "Sulphur-Point": {
        "family": "Sulphur Point",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Sumana": {
        "family": "Sumana",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Sunflower": {
        "family": "Sunflower",
        "category": "sans-serif",
        "variants": [
            "300",
            "500",
            "700"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Sunshiney": {
        "family": "Sunshiney",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Supermercado-One": {
        "family": "Supermercado One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Sura": {
        "family": "Sura",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Suranna": {
        "family": "Suranna",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Suravaram": {
        "family": "Suravaram",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Suwannaphum": {
        "family": "Suwannaphum",
        "category": "serif",
        "variants": [
            "100",
            "300",
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Swanky-and-Moo-Moo": {
        "family": "Swanky and Moo Moo",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Syncopate": {
        "family": "Syncopate",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Syne": {
        "family": "Syne",
        "category": "sans-serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Syne-Mono": {
        "family": "Syne Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Syne-Tactile": {
        "family": "Syne Tactile",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Tajawal": {
        "family": "Tajawal",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Tangerine": {
        "family": "Tangerine",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Taprom": {
        "family": "Taprom",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "khmer",
            "latin"
        ]
    },
    "Tauri": {
        "family": "Tauri",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Taviraj": {
        "family": "Taviraj",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Teko": {
        "family": "Teko",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Telex": {
        "family": "Telex",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Tenali-Ramakrishna": {
        "family": "Tenali Ramakrishna",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Tenor-Sans": {
        "family": "Tenor Sans",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Text-Me-One": {
        "family": "Text Me One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Texturina": {
        "family": "Texturina",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Thasadith": {
        "family": "Thasadith",
        "category": "sans-serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "The-Girl-Next-Door": {
        "family": "The Girl Next Door",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "The-Nautigal": {
        "family": "The Nautigal",
        "category": "handwriting",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Tienne": {
        "family": "Tienne",
        "category": "serif",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Tillana": {
        "family": "Tillana",
        "category": "handwriting",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Timmana": {
        "family": "Timmana",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "telugu"
        ]
    },
    "Tinos": {
        "family": "Tinos",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Titan-One": {
        "family": "Titan One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Titillium-Web": {
        "family": "Titillium Web",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Tomorrow": {
        "family": "Tomorrow",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Tourney": {
        "family": "Tourney",
        "category": "display",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Trade-Winds": {
        "family": "Trade Winds",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Train-One": {
        "family": "Train One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Trirong": {
        "family": "Trirong",
        "category": "serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "thai",
            "vietnamese"
        ]
    },
    "Trispace": {
        "family": "Trispace",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Trocchi": {
        "family": "Trocchi",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Trochut": {
        "family": "Trochut",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Truculenta": {
        "family": "Truculenta",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Trykker": {
        "family": "Trykker",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Tulpen-One": {
        "family": "Tulpen One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Turret-Road": {
        "family": "Turret Road",
        "category": "display",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "700",
            "800"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Twinkle-Star": {
        "family": "Twinkle Star",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Ubuntu": {
        "family": "Ubuntu",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Ubuntu-Condensed": {
        "family": "Ubuntu Condensed",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Ubuntu-Mono": {
        "family": "Ubuntu Mono",
        "category": "monospace",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "greek-ext",
            "latin",
            "latin-ext"
        ]
    },
    "Uchen": {
        "family": "Uchen",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "tibetan"
        ]
    },
    "Ultra": {
        "family": "Ultra",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Uncial-Antiqua": {
        "family": "Uncial Antiqua",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Underdog": {
        "family": "Underdog",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext"
        ]
    },
    "Unica-One": {
        "family": "Unica One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "UnifrakturCook": {
        "family": "UnifrakturCook",
        "category": "display",
        "variants": [
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "UnifrakturMaguntia": {
        "family": "UnifrakturMaguntia",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Unkempt": {
        "family": "Unkempt",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Unlock": {
        "family": "Unlock",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Unna": {
        "family": "Unna",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Urbanist": {
        "family": "Urbanist",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "VT323": {
        "family": "VT323",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Vampiro-One": {
        "family": "Vampiro One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Varela": {
        "family": "Varela",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Varela-Round": {
        "family": "Varela Round",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "hebrew",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Varta": {
        "family": "Varta",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Vast-Shadow": {
        "family": "Vast Shadow",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Vesper-Libre": {
        "family": "Vesper Libre",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Viaoda-Libre": {
        "family": "Viaoda Libre",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Vibes": {
        "family": "Vibes",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "arabic",
            "latin"
        ]
    },
    "Vibur": {
        "family": "Vibur",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Vidaloka": {
        "family": "Vidaloka",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Viga": {
        "family": "Viga",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Voces": {
        "family": "Voces",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Volkhov": {
        "family": "Volkhov",
        "category": "serif",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Vollkorn": {
        "family": "Vollkorn",
        "category": "serif",
        "variants": [
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "greek",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Vollkorn-SC": {
        "family": "Vollkorn SC",
        "category": "serif",
        "variants": [
            "400",
            "600",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Voltaire": {
        "family": "Voltaire",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Vujahday-Script": {
        "family": "Vujahday Script",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Waiting-for-the-Sunrise": {
        "family": "Waiting for the Sunrise",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Wallpoet": {
        "family": "Wallpoet",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Walter-Turncoat": {
        "family": "Walter Turncoat",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Warnes": {
        "family": "Warnes",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Waterfall": {
        "family": "Waterfall",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Wellfleet": {
        "family": "Wellfleet",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Wendy-One": {
        "family": "Wendy One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "WindSong": {
        "family": "WindSong",
        "category": "handwriting",
        "variants": [
            "400",
            "500"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Wire-One": {
        "family": "Wire One",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Work-Sans": {
        "family": "Work Sans",
        "category": "sans-serif",
        "variants": [
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Xanh-Mono": {
        "family": "Xanh Mono",
        "category": "monospace",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Yaldevi": {
        "family": "Yaldevi",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "sinhala"
        ]
    },
    "Yanone-Kaffeesatz": {
        "family": "Yanone Kaffeesatz",
        "category": "sans-serif",
        "variants": [
            "200",
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "cyrillic",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Yantramanav": {
        "family": "Yantramanav",
        "category": "sans-serif",
        "variants": [
            "100",
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Yatra-One": {
        "family": "Yatra One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "devanagari",
            "latin",
            "latin-ext"
        ]
    },
    "Yellowtail": {
        "family": "Yellowtail",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Yeon-Sung": {
        "family": "Yeon Sung",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "korean",
            "latin"
        ]
    },
    "Yeseva-One": {
        "family": "Yeseva One",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "cyrillic-ext",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Yesteryear": {
        "family": "Yesteryear",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Yomogi": {
        "family": "Yomogi",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Yrsa": {
        "family": "Yrsa",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext",
            "vietnamese"
        ]
    },
    "Yuji-Boku": {
        "family": "Yuji Boku",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Yuji-Hentaigana-Akari": {
        "family": "Yuji Hentaigana Akari",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Yuji-Hentaigana-Akebono": {
        "family": "Yuji Hentaigana Akebono",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Yuji-Mai": {
        "family": "Yuji Mai",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Yuji-Syuku": {
        "family": "Yuji Syuku",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Yusei-Magic": {
        "family": "Yusei Magic",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "ZCOOL-KuaiLe": {
        "family": "ZCOOL KuaiLe",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "ZCOOL-QingKe-HuangYou": {
        "family": "ZCOOL QingKe HuangYou",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "ZCOOL-XiaoWei": {
        "family": "ZCOOL XiaoWei",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Zen-Antique": {
        "family": "Zen Antique",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Antique-Soft": {
        "family": "Zen Antique Soft",
        "category": "serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Dots": {
        "family": "Zen Dots",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Kaku-Gothic-Antique": {
        "family": "Zen Kaku Gothic Antique",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Kaku-Gothic-New": {
        "family": "Zen Kaku Gothic New",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Kurenaido": {
        "family": "Zen Kurenaido",
        "category": "sans-serif",
        "variants": [
            "400"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Loop": {
        "family": "Zen Loop",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Maru-Gothic": {
        "family": "Zen Maru Gothic",
        "category": "sans-serif",
        "variants": [
            "300",
            "400",
            "500",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Old-Mincho": {
        "family": "Zen Old Mincho",
        "category": "serif",
        "variants": [
            "400",
            "700",
            "900"
        ],
        "subsets": [
            "cyrillic",
            "greek",
            "japanese",
            "latin",
            "latin-ext"
        ]
    },
    "Zen-Tokyo-Zoo": {
        "family": "Zen Tokyo Zoo",
        "category": "display",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Zeyada": {
        "family": "Zeyada",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "latin"
        ]
    },
    "Zhi-Mang-Xing": {
        "family": "Zhi Mang Xing",
        "category": "handwriting",
        "variants": [
            "400"
        ],
        "subsets": [
            "chinese-simplified",
            "latin"
        ]
    },
    "Zilla-Slab": {
        "family": "Zilla Slab",
        "category": "serif",
        "variants": [
            "300",
            "400",
            "500",
            "600",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    },
    "Zilla-Slab-Highlight": {
        "family": "Zilla Slab Highlight",
        "category": "display",
        "variants": [
            "400",
            "700"
        ],
        "subsets": [
            "latin",
            "latin-ext"
        ]
    }
}